export const CHANGE_LOCALE = 'app/LanguageToggle/CHANGE_LOCALE'
export const CHANGE_LOCALE_DONE = 'app/LanguageToggle/CHANGE_LOCALE_DONE'
